// @flow
import React, { Component } from 'react';
import 'app/common/react/components/profile/showcase/ShowcaseInfo/ShowcaseInfo.scss';
import CONST from 'app/common/lib/Const';
import cx from 'classnames';
import i18n from 'app/common/lib/i18n';
import NavigateLink from 'app/common/react/ui/NavigateLink';
import PinCount from 'app/common/react/components/common/Count/PinCount';
import PropTypes from 'prop-types';
import { ShowcaseShopProps } from 'app/common/react/components/profile/showcase/ShopShowcaseSection/ShopShowcaseSection';
import type {
  AnimationDirection,
  ShowcaseArticleType,
  ShowcaseBoardType,
  ShowcaseShopType,
} from 'app/common/react/components/profile/showcase/commonTypes';
import {
  ANIMATION_DIRECTION,
  ShowcaseArticleProps,
  ShowcaseBoardProps,
} from 'app/common/react/components/profile/showcase/commonTypes';
import { Heading, Text } from 'gestalt';

type ShowcaseInfoType = {
  animationDirection: ?AnimationDirection,
  currentSection: ?(ShowcaseBoardType | ShowcaseArticleType | ShowcaseShopType),
  viewingOwnProfile: boolean,
};

const HELP_CENTER_SHOWCASE_URL = CONST.GEN.templateConst.settings.HELP_SHOWCASE;

export class ShowcaseInfo extends Component<ShowcaseInfoType> {
  getSectionId() {
    const { currentSection } = this.props;
    if (!currentSection) {
      return '';
    }

    switch (currentSection.type) {
      case CONST.SHOWCASE_TYPE_BOARD:
        return currentSection.id;
      case CONST.SHOWCASE_TYPE_ARTICLE:
        return currentSection.id;
      case CONST.SHOWCASE_TYPE_SHOP:
        const { link_data } = currentSection;
        const { id: merchantID } = link_data;
        return merchantID;
      default:
        break;
    }
    return undefined;
  }

  renderTitleAndSubtitle() {
    const { currentSection, viewingOwnProfile } = this.props;
    let title, subtitle, showHelpCenterLink;
    showHelpCenterLink = false;
    if (currentSection && currentSection.type === CONST.SHOWCASE_TYPE_BOARD) {
      title = currentSection.name;
      subtitle = <PinCount count={currentSection.pin_count} />;
    } else if (
      currentSection &&
      currentSection.type === CONST.SHOWCASE_TYPE_ARTICLE &&
      currentSection.title &&
      currentSection.subtitle
    ) {
      title = currentSection.title.format;
      subtitle = currentSection.subtitle.format;
    } else if (currentSection && currentSection.type === CONST.SHOWCASE_TYPE_SHOP) {
      title = currentSection.layout_params.title;
      subtitle = currentSection.layout_params.subtitle;
    } else if (!currentSection && viewingOwnProfile) {
      // Empty Section Case
      title = i18n._('Build your showcase');
      subtitle = i18n._(
        "New! Welcome visitors with a big, beautiful showcase of ideas they'll love.",
      );
      showHelpCenterLink = true;
    } else {
      return null;
    }

    return (
      <div className="titleWrapper">
        <Heading size="xs">{title}</Heading>
        <div className="subtitleWrapper">
          <Text color="gray" inline size="sm" smSize="xs" mdSize="xs" lgSize="sm">
            {subtitle}
          </Text>
          {showHelpCenterLink && (
            <NavigateLink
              className="inline-block helpCenterLink"
              to={HELP_CENTER_SHOWCASE_URL}
              useNewTab
            >
              <Text bold color="gray" size="sm" smSize="xs" mdSize="xs" lgSize="sm">
                {i18n._('Learn more')}
              </Text>
            </NavigateLink>
          )}
        </div>
      </div>
    );
  }

  render() {
    const { animationDirection } = this.props;
    const classNames = cx(
      'ShowcaseInfo',
      'flex',
      { sectionInfoSlideFromRight: animationDirection === ANIMATION_DIRECTION.RIGHT },
      { sectionInfoSlideFromLeft: animationDirection === ANIMATION_DIRECTION.LEFT },
    );
    return (
      <div className={classNames} key={this.getSectionId()}>
        {this.renderTitleAndSubtitle()}
      </div>
    );
  }
}

ShowcaseInfo.propTypes = {
  animationDirection: PropTypes.string,
  currentSection: PropTypes.oneOfType([
    ShowcaseBoardProps,
    ShowcaseArticleProps,
    ShowcaseShopProps,
  ]),
  viewingOwnProfile: PropTypes.bool.isRequired,
};

export default ShowcaseInfo;
